import request from '@/utils/request'

export function getUserList() {
  return request({
    url: '/chat/userList',
    method: 'get'
  })
}

export function getSessions() {
  return request({
    url: '/chat/sessions',
    method: 'get'
  })
}

export function getMessages(sessionId) {
  return request({
    url: '/chat/messages',
    method: 'get',
    params: { sessionId }
  })
}

export function getMessagesByUser(userId) {
  return request({
    url: '/chat/messages/user',
    method: 'get',
    params: { userId }
  })
}

export function updateProfile(data) {
  return request({
    url: '/chat/updateProfile',
    method: 'post',
    data
  })
}

export function changePassword(data) {
  return request({
    url: '/chat/changePassword',
    method: 'post',
    data
  })
}

export function getAdminInfo() {
  return request({
    url: '/chat/adminInfo',
    method: 'get'
  })
}

export function uploadAvatar(formData) {
  return request({
    url: '/chat/uploadAvatar',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function changeEmail(data) {
  return request({
    url: '/chat/changeEmail',
    method: 'post',
    data
  })
}

export function changePhone(data) {
  return request({
    url: '/chat/changePhone',
    method: 'post',
    data
  })
}

export function getUnreadCount() {
  return request({
    url: '/chat/unreadCount',
    method: 'get'
  })
}

export function clearUnreadCount(data) {
  return request({
    url: '/chat/clearUnreadCount',
    method: 'post',
    data
  })
}

export function uploadImage(formData) {
  return request({
    url: '/chat/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function setAlias(data) {
  return request({
    url: '/chat/setAlias',
    method: 'post',
    data
  })
}

export function getAlias(targetUserId) {
  return request({
    url: '/chat/getAlias',
    method: 'get',
    params: { targetUserId }
  })
}

export function recallMessage(messageId) {
  return request({
    url: '/chat/recallMessage',
    method: 'post',
    data: { messageId }
  })
}

// 获取用户自定义表情列表
export function getCustomEmojis() {
  return request({
    url: '/chat/getCustomEmojis',
    method: 'get'
  })
}

// 上传自定义表情
export function uploadCustomEmoji(formData) {
  return request({
    url: '/chat/uploadCustomEmoji',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除自定义表情
export function deleteCustomEmoji(emojiId) {
  return request({
    url: '/chat/deleteCustomEmoji',
    method: 'post',
    data: { emojiId }
  })
}

// 从URL保存表情到自己的表情包
export function saveEmojiFromUrl(emojiUrl, isGif) {
  return request({
    url: '/chat/saveEmojiFromUrl',
    method: 'post',
    data: { emojiUrl, isGif: isGif || 0 }
  })
}

// 催Ta上线
export function urgeOnline(targetUserId, reason) {
  return request({
    url: '/chat/urgeOnline',
    method: 'post',
    data: { targetUserId, reason }
  })
}

// 获取催Ta上线倒计时
export function getUrgeOnlineCountdown(targetUserId) {
  return request({
    url: '/chat/getUrgeOnlineCountdown',
    method: 'get',
    params: { targetUserId }
  })
}

// 拍一拍
export function patPat(targetUserId) {
  return request({
    url: '/chat/patPat',
    method: 'post',
    data: { targetUserId }
  })
}

// 检查并设置用户上线音频倒计时
export function checkAndSetOnlineAudioCooldown(targetUserId) {
  return request({
    url: '/chat/checkAndSetOnlineAudioCooldown',
    method: 'post',
    data: { targetUserId }
  })
}

// 保存用户最后聊天对象
export function saveLastChatUser(targetUserId) {
  return request({
    url: '/chat/saveLastChatUser',
    method: 'post',
    data: { targetUserId }
  })
}

// 获取用户最后聊天对象
export function getLastChatUser() {
  return request({
    url: '/chat/getLastChatUser',
    method: 'get'
  })
}

